module.exports = __webpack_public_path__ + "img/194.6b769185.png";